import { combineReducers } from 'redux';

import applications from './applications/reducer';
import organisations from './organisations/reducer';

export default combineReducers({
  applications,
  organisations,
});
